<template>
  <div :class="isMobile ? 'mobile formWrapper' : 'formWrapper'">
    <el-form :model="form" :rules="rules" ref="form" class="form">
      <el-form-item label-width="0" prop="phone" class="formItem phone">
        <el-input placeholder="请输入手机号" v-model="form.phone">
          <template v-if="isMobile" slot="prefix">
            <span class="prefix">+86</span>
          </template>
        </el-input>
      </el-form-item>
      <el-form-item label-width="0" prop="code" class="formItem">
        <el-input placeholder="请输入验证码" v-model="form.code">
          <template slot="suffix">
            <el-button
              :disabled="countdown > 0 || form.phone === ''"
              @click="getCode"
              type="text"
              class="getCodeButton"
            >
              {{ countdown > 0 ? countdown + "秒" : "获取验证码" }}
            </el-button>
          </template>
        </el-input>
      </el-form-item>
      <el-button
        type="primary"
        @click="submitForm('form')"
        class="formItem formButton"
        :disabled="!form.policy || form.phone === '' || form.phone === ''"
      >
        登录/注册
      </el-button>
      <el-form-item>
        <el-checkbox-group v-model="form.policy">
          <el-checkbox name="policy" class="checkbox">
            登录代表您已阅读并同意
            <el-link
              type="primary"
              href="http://ai.cemeta.cenmetahome.cn/article"
              target="_blank"
            >
              《隐私政策》
            </el-link>
            和
            <el-link
              type="primary"
              href="http://ai.cemeta.cenmetahome.cn/service"
              target="_blank"
              >《使用条款》</el-link
            >
          </el-checkbox>
        </el-checkbox-group>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import Api from "../../http/api";
export default {
  name: "VerifyCode",
  data() {
    return {
      countdown: 0,
      timer: null,
      form: {
        phone: "",
        code: "",
        policy: false,
      },
      rules: {
        phone: [{ required: true, message: "请输入手机号", trigger: "blur" }],
        code: [{ required: true, message: "请输入验证码", trigger: "blur" }],
      },
      isMobile: false,
    };
  },
  methods: {
    async getCode() {
      if (!this.form.phone) {
        return;
      }
      await Api.Account.getCode(this.form.phone);
      this.countdown = 59;
      this.timer = setInterval(() => {
        if (this.countdown > 0) {
          this.countdown--;
        } else {
          clearInterval(this.timer);
          this.timer = null;
        }
      }, 1000);
    },
    submitForm(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          _baq.track("active_register", { assets_id: "1772924118818887" });

          const res = await Api.Account.login({
            type: "code",
            payload: {
              phone: this.form.phone,
              code: this.form.code,
            },
          });

          if (res.error) {
            this.$message.error("登录失败");
            return;
          }
          const { token, user } = res.data;
          localStorage.setItem("token", token);
          localStorage.setItem("userId", user.id);
          localStorage.setItem("name", user.name);
          localStorage.setItem("phone", this.form.phone);
          localStorage.setItem("role", user.role);

          this.$store.dispatch("setToken");
          this.$store.dispatch("setUser");

          location.href = "/";
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  },
  watch: {
    countdown: {
      handler(newVal) {
        this.countdown = newVal;
      },
    },
  },
  created() {
    this.isMobile = window.navigator.userAgent.includes("Mobile");
  },
};
</script>
<style lang="less" scoped>
.formWrapper {
  width: 400px;

  .form {
    .formItem {
      width: 100%;

      .el-input__inner {
        background-color: #f3f4f5;
      }
    }

    .formButton {
      margin-top: 24px;
      background-color: #526aee;
    }

    .getCodeButton {
      border-left: solid 1px #111d3a;
      padding: 0 12px;
      color: #526aee;
      border-radius: 0;
    }
    .el-checkbox__input.is-checked + .el-checkbox__label {
      color: #526aee !important;
    }
  }
}

.mobile {
  &.formWrapper {
    width: unset;

    .formItem {
      height: 52px;
      border-radius: 26px;
    }
    .getCodeButton {
      color: #111d3a;
    }
    .prefix {
      padding: 0 12px;
      color: #111d3a;
    }

    .phone {
      /deep/ .el-input__inner {
        padding-left: 56px;
      }
    }

    .formButton {
      background: linear-gradient(150deg, #7ba0ff, #ee74ff);
    }
    .checkbox {
      display: flex;
      margin-top: 40px;
    }
  }

  /deep/ .el-input__inner {
    border-radius: 26px;
  }

  /deep/ .el-checkbox__label {
    white-space: initial;
    flex: 1;
  }

  /deep/ .el-input-group__prepend {
    border-radius: 26px;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
    color: #111d3a;
    background: white;
  }
  /deep/ .el-input-group--prepend .el-input__inner {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/login/VerifyCode.vue